// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Staatliches&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
    width: 100%;
    height: 80px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: 'Staatliches', sans-serif;
    font-weight: normal;
    padding: 0rem;
    z-index: 2;
    font-size: 3dvh;
}

.hamburger {
    display: block; /* Ensure the hamburger menu is always displayed */
    cursor: pointer;
}

.mobile-menu {
    display: none;
    position: absolute;
    text-transform: none;
    top: 80px;
    left: 50%;
    transform: translateX(-50%);
    flex-direction: column-reverse; /* Ensure vertical stacking */
    padding: 0 10px 0 10px;
    align-items: center;
    transition: 0.1s;
    color: var(--hellgruen);
    background-color: var(--blassblau);
    border-radius: 10px;
    z-index: 10;
}

.mobile-menu.active {
    display: flex;
    border: 10px;
}

.mobile-menu li {
    margin: 0; /* Remove horizontal margin */
    width: 100%; /* Ensure full width for each item */
    text-align: center; /* Center text */
}

.mobile-menu a {
    padding: 0.2rem;
    margin: 0; /* Remove horizontal margin */
    text-align: center; /* Center text */
    color: var(--hellblau);
    background-color: var(--blassblau);
    font-family: 'Staatliches', sans-serif;
    font-weight: normal;
}

.mobile-menu .active-item {
    background-color: var(--blassgruen); /* Highlight background color */
    font-weight: normal;
    border-radius: 10px; /* Add some rounding */
}

.mobile-nav {
    margin: 1rem 0;
    display: flex;
    flex-direction: column;
}

.nav-menu {
    display: none;
}

.nav-icon {
    display: block;
}

.logo * {
    color: var(--hellblau); /* Match the text color */
}

.logo svg {
    border: none; /* Ensure no border is applied */
    outline: none; /* Ensure no outline is applied */
}

.map-icon {
    font-size: 1.8rem;
}

.logo-text {
    text-decoration: underline;
    text-underline-offset: 4px;
    font-family: 'Staatliches', sans-serif;
}

.navbar-left {
    flex: 1 1;
    display: flex;
    justify-content: flex-start;
}

.navbar-right {
    flex: 1 1;
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
}

@media print {
  .navbar {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/navbar/Navbarstyle.css"],"names":[],"mappings":"AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,sCAAsC;IACtC,mBAAmB;IACnB,aAAa;IACb,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,cAAc,EAAE,kDAAkD;IAClE,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,oBAAoB;IACpB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,8BAA8B,EAAE,6BAA6B;IAC7D,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,kCAAkC;IAClC,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,SAAS,EAAE,6BAA6B;IACxC,WAAW,EAAE,oCAAoC;IACjD,kBAAkB,EAAE,gBAAgB;AACxC;;AAEA;IACI,eAAe;IACf,SAAS,EAAE,6BAA6B;IACxC,kBAAkB,EAAE,gBAAgB;IACpC,sBAAsB;IACtB,kCAAkC;IAClC,sCAAsC;IACtC,mBAAmB;AACvB;;AAEA;IACI,mCAAmC,EAAE,+BAA+B;IACpE,mBAAmB;IACnB,mBAAmB,EAAE,sBAAsB;AAC/C;;AAEA;IACI,cAAc;IACd,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB,EAAE,yBAAyB;AACrD;;AAEA;IACI,YAAY,EAAE,gCAAgC;IAC9C,aAAa,EAAE,iCAAiC;AACpD;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,sCAAsC;AAC1C;;AAEA;IACI,SAAO;IACP,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,SAAO;IACP,aAAa;IACb,yBAAyB;IACzB,SAAS;AACb;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Staatliches&display=swap');\n\n.navbar {\n    width: 100%;\n    height: 80px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-family: 'Staatliches', sans-serif;\n    font-weight: normal;\n    padding: 0rem;\n    z-index: 2;\n    font-size: 3dvh;\n}\n\n.hamburger {\n    display: block; /* Ensure the hamburger menu is always displayed */\n    cursor: pointer;\n}\n\n.mobile-menu {\n    display: none;\n    position: absolute;\n    text-transform: none;\n    top: 80px;\n    left: 50%;\n    transform: translateX(-50%);\n    flex-direction: column-reverse; /* Ensure vertical stacking */\n    padding: 0 10px 0 10px;\n    align-items: center;\n    transition: 0.1s;\n    color: var(--hellgruen);\n    background-color: var(--blassblau);\n    border-radius: 10px;\n    z-index: 10;\n}\n\n.mobile-menu.active {\n    display: flex;\n    border: 10px;\n}\n\n.mobile-menu li {\n    margin: 0; /* Remove horizontal margin */\n    width: 100%; /* Ensure full width for each item */\n    text-align: center; /* Center text */\n}\n\n.mobile-menu a {\n    padding: 0.2rem;\n    margin: 0; /* Remove horizontal margin */\n    text-align: center; /* Center text */\n    color: var(--hellblau);\n    background-color: var(--blassblau);\n    font-family: 'Staatliches', sans-serif;\n    font-weight: normal;\n}\n\n.mobile-menu .active-item {\n    background-color: var(--blassgruen); /* Highlight background color */\n    font-weight: normal;\n    border-radius: 10px; /* Add some rounding */\n}\n\n.mobile-nav {\n    margin: 1rem 0;\n    display: flex;\n    flex-direction: column;\n}\n\n.nav-menu {\n    display: none;\n}\n\n.nav-icon {\n    display: block;\n}\n\n.logo * {\n    color: var(--hellblau); /* Match the text color */\n}\n\n.logo svg {\n    border: none; /* Ensure no border is applied */\n    outline: none; /* Ensure no outline is applied */\n}\n\n.map-icon {\n    font-size: 1.8rem;\n}\n\n.logo-text {\n    text-decoration: underline;\n    text-underline-offset: 4px;\n    font-family: 'Staatliches', sans-serif;\n}\n\n.navbar-left {\n    flex: 1;\n    display: flex;\n    justify-content: flex-start;\n}\n\n.navbar-right {\n    flex: 1;\n    display: flex;\n    justify-content: flex-end;\n    gap: 1rem;\n}\n\n@media print {\n  .navbar {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
